import { render, staticRenderFns } from "./EditBulkClaimAmountDialog.vue?vue&type=template&id=079daa74&scoped=true&lang=pug&"
import script from "./EditBulkClaimAmountDialog.vue?vue&type=script&lang=js&"
export * from "./EditBulkClaimAmountDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079daa74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow,VSpacer})
